module.exports = __webpack_public_path__ + "img/route@2x.ad897387.png";